import { render, staticRenderFns } from "./orders__form.vue?vue&type=template&id=b9664ff2"
import script from "./orders__form.vue?vue&type=script&lang=js"
export * from "./orders__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports